import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { orderBy } from 'lodash';
/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n';
import { Toolbar, Slot, DropdownMenu } from '@wordpress/components';
var POPOVER_PROPS = {
  position: 'bottom left'
};

var FormatToolbar = function FormatToolbar() {
  return createElement("div", {
    className: "editor-format-toolbar block-editor-format-toolbar"
  }, createElement(Toolbar, null, ['bold', 'italic', 'link'].map(function (format) {
    return createElement(Slot, {
      name: "RichText.ToolbarControls.".concat(format),
      key: format
    });
  }), createElement(Slot, {
    name: "RichText.ToolbarControls"
  }, function (fills) {
    return fills.length !== 0 && createElement(DropdownMenu, {
      icon: false,
      label: __('More rich text controls'),
      controls: orderBy(fills.map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
            props = _ref2[0].props;

        return props;
      }), 'title'),
      popoverProps: POPOVER_PROPS
    });
  })));
};

export default FormatToolbar;
//# sourceMappingURL=index.js.map